/**
 * PreviewAgb — AGB (Allgemeine Geschäftsbedingungen) content page preview
 */

interface PreviewAgbProps {
  settings: {
    companyLegal?: {
      name?: string;
    };
    agb?: {
      gerichtsstand?: string;
      zahlungsfrist?: string;
    };
    [key: string]: any;
  };
  components: any;
}

export function PreviewAgb({ settings }: PreviewAgbProps) {
  const legal = settings.companyLegal || {};
  const agb = settings.agb || {};
  const gerichtsstand = agb.gerichtsstand || 'Bern';
  const zahlungsfrist = agb.zahlungsfrist || '30 Tage';

  return (
    <div className="legal-page">
      <div className="container">
        <h1>Allgemeine Gesch&auml;ftsbedingungen (AGB)</h1>

        <h2>1. Geltungsbereich</h2>
        <p>Diese Allgemeinen Gesch&auml;ftsbedingungen (AGB) gelten f&uuml;r alle Gesch&auml;ftsbeziehungen zwischen {legal.name || 'dem Anbieter'} (nachfolgend &laquo;Anbieter&raquo;) und dem Kunden. Abweichende Bedingungen des Kunden werden nicht anerkannt, es sei denn, der Anbieter stimmt diesen ausdr&uuml;cklich schriftlich zu.</p>

        <h2>2. Vertragsschluss</h2>
        <p>Ein Vertrag kommt zustande durch die schriftliche Auftragsbestätigung des Anbieters oder durch Beginn der Leistungserbringung. Angebote des Anbieters sind freibleibend und unverbindlich, sofern nicht ausdr&uuml;cklich anders vereinbart.</p>

        <h2>3. Leistungsumfang</h2>
        <p>Der Umfang der Leistungen ergibt sich aus der jeweiligen Auftragsbestätigung oder dem individuellen Vertrag. &Auml;nderungen oder Erweiterungen des Leistungsumfangs bed&uuml;rfen der schriftlichen Vereinbarung.</p>

        <h2>4. Preise und Zahlungsbedingungen</h2>
        <p>Alle Preise verstehen sich in Schweizer Franken (CHF) und zuz&uuml;glich der gesetzlichen Mehrwertsteuer, sofern nicht anders angegeben. Rechnungen sind innert {zahlungsfrist} nach Rechnungsdatum ohne Abzug zahlbar.</p>
        <p>Bei Zahlungsverzug ist der Anbieter berechtigt, Verzugszinsen von 5% p.a. zu erheben sowie Mahngeb&uuml;hren in Rechnung zu stellen.</p>

        <h2>5. Mitwirkungspflichten des Kunden</h2>
        <p>Der Kunde stellt dem Anbieter alle zur Leistungserbringung erforderlichen Unterlagen, Informationen und Zugänge rechtzeitig und kostenlos zur Verf&uuml;gung. Verz&ouml;gerungen aufgrund mangelnder Mitwirkung gehen nicht zu Lasten des Anbieters.</p>

        <h2>6. Geistiges Eigentum</h2>
        <p>Alle Urheberrechte und sonstigen Schutzrechte an den vom Anbieter erstellten Werken verbleiben beim Anbieter, bis die vollst&auml;ndige Bezahlung erfolgt ist. Nach vollst&auml;ndiger Bezahlung gehen die vereinbarten Nutzungsrechte auf den Kunden &uuml;ber.</p>

        <h2>7. Gew&auml;hrleistung und Haftung</h2>
        <p>Der Anbieter erbringt seine Leistungen nach bestem Wissen und Gewissen. Die Haftung f&uuml;r leichte Fahrl&auml;ssigkeit wird ausgeschlossen, soweit gesetzlich zul&auml;ssig. Die Haftung ist in jedem Fall auf den Auftragswert beschr&auml;nkt.</p>
        <p>F&uuml;r indirekte Sch&auml;den, Folgesch&auml;den oder entgangenen Gewinn wird keine Haftung &uuml;bernommen.</p>

        <h2>8. Vertraulichkeit</h2>
        <p>Beide Parteien verpflichten sich, vertrauliche Informationen der anderen Partei nicht an Dritte weiterzugeben und nur zum Zweck der Vertragserf&uuml;llung zu verwenden. Diese Pflicht besteht auch nach Beendigung des Vertragsverh&auml;ltnisses.</p>

        <h2>9. K&uuml;ndigung</h2>
        <p>Laufende Vertr&auml;ge k&ouml;nnen von beiden Seiten unter Einhaltung einer Frist von 30 Tagen zum Monatsende gek&uuml;ndigt werden, sofern nicht anders vereinbart. Das Recht zur fristlosen K&uuml;ndigung aus wichtigem Grund bleibt vorbehalten.</p>

        <h2>10. Anwendbares Recht und Gerichtsstand</h2>
        <p>Es gilt ausschliesslich Schweizer Recht. Gerichtsstand ist {gerichtsstand}, Schweiz.</p>

        <p><a href="index.html">&larr; Zur&uuml;ck zur Startseite</a></p>
      </div>
    </div>
  );
}
